// Ключи локального хранилища
export const StorageKeys = {
    /** Глобавльный perPage для таблиц */
    GLOBAL_TABLE_PER_PAGE: 'ks-global-table-per-page',
    /** Мониторинг */
    // выбранная для отображения колонка частотки таблицы
    MONITORING_WS_SELECTED_COLUMN: 'ks-monitoring-ws-selected-column',
    // состояние отображения графика
    MONITORING_VISIBILITY_CHART: 'ks-monitoring-visibility-chart',
    // состояние отображения ответов ИИ в таблице
    MONITORING_VISIBILITY_AI_ANSWER: 'ks-monitoring-visibility-ai-answer',
    /** Квалификация */
    // данные опроса
    QUALIFICATION_DATA: 'ks-qualification-data',
    // URL возврата после квалификации
    QUALIFICATION_REDIRECT: 'ks-qualification-redirect',
    /** SERP, WS, Cluster projects - переключатель типа отображения проектов, Основные или ВСЕ */
    CHILD_PROJECTS_LIST_TYPES_MODE_SELECTOR: 'ks-child-projects-list-types-mode-selector',
    /** Меню */
    // схлопывание
    LEFT_MENU_COLLAPSE: 'ks-left-menu-collapse',
    // разворачивание "Избранное"
    LEFT_MENU_FAVORITE_EXPANDED: 'ks-left-menu-favorite-expanded',
    /** AiTracker */
    // состояние отображения графика
    AI_TRACKER_VISIBILITY_CHART: 'ks-ai-tracker-visibility-chart',
    // тип графика
    AI_TRACKER_CHART_TYPE: 'ks-ai-tracker-chart-type',
    // данные закрытого попап создания проекта
    AI_TRACKER_CREAT_PROJECT_DATA: 'ks-ai-tracker-create-project-data',
    /** БАННЕРЫ */
    // закрыли баннер 2025.11 черная ai пятница
    BANNER_2025_11_BLACK_AI_FRIDAY_CLOSED: 'ks-banner-2025-11-black-ai-friday-closed',
    // закрыли баннер 2026.04.20 пятюня
    BANNER_2026_04_PYATYUNYA_CLOSED: 'ks-banner-2026-04-pyatyunya-closed',
    // закрыли баннер 2026.05 11 лет
    BANNER_2026_05_11_YEARS_CLOSED: 'ks-banner-2026-05-11-years-closed',
}
